/**
 * スクロール系制御で表示されるコントローラーの制御
 */

import type { AppEnv } from '../../utils/env'

/**
 * スクロールコントローラーの制御を初期化
 */
export const initScrollController = (env: AppEnv): void => {
  //コントローラーの表示切換え制御
    const scrollElm = document.querySelector<HTMLElement>('.p-scrl')
    if(scrollElm) {
        window.addEventListener('scroll', () => {
            if(window.scrollY > 300) {
                scrollElm.classList.add('is-active')
            }
            else {
                scrollElm.classList.remove('is-active')
            }
        })
    }

  //コントローラー内アクション
    const scrollButtonUp = document.querySelector<HTMLElement>('.p-scrl_up')
    if(scrollButtonUp) {
        scrollButtonUp.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        })
    }
    const scrollButtonMypage = document.querySelector<HTMLElement>('.p-scrl_mypg')
    if(scrollButtonMypage) {
        scrollButtonMypage.addEventListener('click', () => {
            location.href = `${env.root}/mypage`
        })
    }
    const scrollButtonInquiry = document.querySelector<HTMLElement>('.p-scrl_inqry')
    if(scrollButtonInquiry) {
        scrollButtonInquiry.addEventListener('click', () => {
            location.href = `${env.root}/inquiry/`
        })
    }
}
